import { Alignment, Button, FormGroup, Tab, Tabs, } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { NFesStore } from "../../stores/nfe/NFesStore";
import { copyToClipboard, gerarPeriodos } from "../../utils";
import { MDBBtn, MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from "mdbreact";
import * as moment from "moment";
import { IEmpresa } from "../../model";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import { toast } from "react-toastify";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import LoadingModal from "../loading/LoadingModal";
import { DateRangePicker10 } from "../utils/DateRangePicker10";
import { NotasStore } from "../../stores/notas/NotasStore";
import TarefasPage from "./TarefasPage";
import { TarefasStore } from "../../stores/notas/TarefasStore";

const numeral = require("numeral");

interface NFesPageProps {}

interface NFesPageState {
  date1: string;
  date2: string;
}

@observer
export class NFesPage extends React.Component<NFesPageProps, NFesPageState> {

  obs = observable({
    selectedPeriod: [] as any,
    selectedEmpresa: newEmpresa() as IEmpresa,
    filtro: "" as string,
    tipo: "" as string,
    loading: false as boolean,
    loading_danfes: false as boolean,
    loading_xmls: false as boolean,
    total_download: 0 as number,
    count_danfes: 0 as number,
    progress: 0.0 as number,
    list: [],
    listChaveEventos: []
  })
  static obs: any;

  constructor(props) {
    super(props);
    AppStore.setTitle('NF-e, NFC-e, CT-e e NFS-e');

    this.state = {
      date1: "",
      date2: ""
    }
  }

  async componentDidMount() {

    NFesStore.obs.imps = []

    await NFesStore.loadEmpresas();

    this.obs.selectedEmpresa = newEmpresa();
    NotasStore.obs.total_notas = 0

    this.obs.list = []
    this.obs.listChaveEventos = []
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState?.date1 !== this.state.date1 || prevState?.date2 !== this.state.date2 || 
      NotasStore.obs.total_notas !== NotasStore.obs.prev_total_notas) {

      NotasStore.obs.prev_total_notas = NotasStore.obs.total_notas;

      if (NotasStore.obs.total_notas > 20000 && this.obs.tipo == "NFC-E") {
        const start = this.state.date1 ? moment(this.state.date1, "YYYY-MM-DD") : null;
        const end = this.state.date2 ? moment(this.state.date2, "YYYY-MM-DD") : null;

        if (start) {
          const { start: finalStart, end: finalEnd } = this.clampPeriod(start, end, 10);

          const currentDiff = end && start ? end.diff(start, "days") + 1 : 10;
          const newDiff = finalEnd && finalStart ? finalEnd.diff(finalStart, "days") + 1 : 10;

          if (!end || currentDiff > newDiff) {
            this.setState({
              date1: finalStart.format("YYYY-MM-DD"),
              date2: finalEnd.format("YYYY-MM-DD"),
            });

            this.obs.selectedPeriod = [finalStart.toDate(), finalEnd.toDate()];
          }
        }
      }
    }
  }

  clampPeriod = (start: moment.Moment | null, end: moment.Moment | null, maxDays = 10) => {
    if (!start) return { start: null, end: null };

    let finalStart = start.clone();
    let finalEnd = end && end.isValid() ? end.clone() : start.clone().add(maxDays - 1, "days");

    if (finalEnd.isBefore(finalStart, "day")) {
      finalEnd = finalStart.clone().add(maxDays - 1, "days");
    }

    const diff = finalEnd.startOf("day").diff(finalStart.startOf("day"), "days") + 1;
    if (diff > maxDays) {
      finalEnd = finalStart.clone().add(maxDays - 1, "days");
    }

    return { start: finalStart, end: finalEnd };

  };

  handleDateChange = (val: any) => {
    const start = val?.[0] ? moment(val[0]) : null;
    const end = val?.[1] ? moment(val[1]) : null;
  
    let finalStart = null;
    let finalEnd = null;
  
    if (start && start.isValid()) {
      finalStart = start;
      finalEnd = start.date() === 1
        ? (end || start.clone().endOf('month'))
        : (end && end.isValid() ? end : null);
    }
  
    this.setState({
      date1: finalStart ? finalStart.format("YYYY-MM-DD") : null,
      date2: finalEnd ? finalEnd.format("YYYY-MM-DD") : null,
    });
  
    this.obs.selectedPeriod = [
      finalStart ? finalStart.toDate() : null,
      finalEnd ? finalEnd.toDate() : null,
    ];

    NFesStore.obs.imps = [];
    this.handleTotalNotas();

  };

  handleDateChange10 = (val: any) => {
    const start = val?.[0] ? moment(val[0]) : null;
    const end = val?.[1] ? moment(val[1]) : null;

    const { start: finalStart, end: finalEnd } = this.clampPeriod(start, end, 10);

    this.setState({
      date1: finalStart ? finalStart.format("YYYY-MM-DD") : null,
      date2: finalEnd ? finalEnd.format("YYYY-MM-DD") : null,
    });

    this.obs.selectedPeriod = [
      finalStart ? finalStart.toDate() : null,
      finalEnd ? finalEnd.toDate() : null,
    ];

    NFesStore.obs.imps = [];
    this.handleTotalNotas();
  };

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Chave, Nº, Valor)"
      />
    );
  };

  handleFilterChange = (e: any) => {
    var string = e.target.value;
    this.obs.filtro = string;
    NFesStore.obs.imps = [];
    this.handleTotalNotas();
  };

  handleFilterTipoChange = (e: any) => {
    var string = e.target.value;
    this.obs.tipo = string;
    NFesStore.obs.imps = [];
    this.handleTotalNotas();
  };

  handleBuscaClick = async () => {
    this.obs.list = []

    if (this.obs.selectedEmpresa.razao_social == "") {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }

    if (this.obs.tipo == "") {
      toast.warning('Selecione um tipo de XML.', {});
      return
    }

    if (this.obs.filtro == "") {
      toast.warning('Selecione a origem.', {});
      return
    }

    if (this.state.date1 == null || this.state.date2 == null) {
      toast.warning('Selecione o período.', {});
      return
    }

    var empresa = this.obs.selectedEmpresa.cnpj;
    var filtro = this.obs.filtro;
    var tipo = this.obs.tipo;
    var date1 = this.state.date1;
    var date2 = this.state.date2;

    this.obs.loading = true
    await NFesStore.setBusca(empresa, tipo, filtro, date1, date2);
    this.obs.loading = false

  }

  handleCheckChange = (row: any) => {
    const { tipo } = this.obs;

    if (tipo === "NFS-E") {

      this.toggleItemNfse(this.obs.list, { chave: row.chave, cancelada: row.cancelada });

    } else {

      this.toggleItem(this.obs.list, row.id);
      this.toggleItem(this.obs.listChaveEventos, row.chave);

    }

  };

  toggleItemNfse = (list: any[], value: any) => {

    const index = list.findIndex(i => i.chave === value.chave);

    if (index === -1) {
      list.push(value);
    } else {
      list.splice(index, 1);
    }

    return list;

  };

  toggleItem = (list: any[], value: any) => {

    const index = list.indexOf(value);

    if (index === -1) {
      list.push(value);
    } else {
      list.splice(index, 1);
    }

  };

  onSelectAll = (isSelect, rows) => {

    this.obs.list = []
    this.obs.listChaveEventos = []

    if (isSelect) {

      if (this.obs.tipo == "NFS-E") {

        this.obs.list = NFesStore.obs.imps?.map(imp => {
          return ({ chave: imp.chave, cancelada: (imp.cancelada || false) })
        });

      } else {

        for (const imp of NFesStore.obs.imps) {
          this.obs.list.push(imp._id);
          this.obs.listChaveEventos.push(imp.chave);
        }

      }

    }

  };

  handleRowSelect = (row, isSelected, e) => {
    if (row.status == "Indisponível") {
      return false;
    } else {
      this.handleCheckChange(row);
    }
  };

  handleDownload = async () => {

    if (this.obs.list.length < 1) {
      toast.warning('Você precisa selecionar os XMLs desejados para realizar o download.', {});
      return
    }

    const ids =
      this.obs.tipo === "NFS-E"
        ? this.obs.list.map(x => x.chave)
        : this.obs.list;

    var documento = {
      ids: ids,
      filtro: this.obs.filtro,
      tipo: this.obs.tipo,
      empresa: this.obs.selectedEmpresa.cnpj,
      data1: this.state.date1,
      data2: this.state.date2,
    };

    this.obs.loading_xmls = true;

    await NFesStore.download_xml(documento, this.obs.selectedEmpresa.razao_social);

    this.obs.loading_xmls = false;

  };

  handleEventos = async () => {

    const ids =
      this.obs.tipo === "NFS-E"
        ? this.obs.list.map(x => x.chave)
        : this.obs.listChaveEventos;

    var documento = {
      chaves: ids,
      empresa: this.obs.selectedEmpresa.cnpj,
      data1: this.state.date1,
      data2: this.state.date2,
      filtro: this.obs.filtro,
      tipo: this.obs.tipo
    };

    if (documento.chaves.length < 1) {
      toast.warning('Você precisa selecionar os XMLs desejados para realizar o download.', {});
      return
    }

    this.obs.loading_xmls = true;

    await NFesStore.download_eventos(documento, this.obs.selectedEmpresa.razao_social);

    this.obs.loading_xmls = false;

  };

  handleDanfe = async () => {

    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    if (is_teste) {
      toast.warning("No período de testes, você não tem permissão para gerar uma DANFE.", {});

    } else {

      if (this.obs.list.length < 1) {
        toast.warning('Você precisa selecionar os XMLs desejados para gerar.', {});
        return
      }

      var ids = {
        ids: this.obs.list,
        filtro: this.obs.filtro,
        tipo: this.obs.tipo,
        razao_social: this.obs.selectedEmpresa.razao_social,
        empresa: this.obs.selectedEmpresa.cnpj,
        data1: this.state.date1,
        data2: this.state.date2,
      };

      this.obs.loading_danfes = true;

      if (this.obs.list.length == 1) {

        await NFesStore.view_danfe(this.obs.selectedEmpresa, ids);

      }

      if (this.obs.list.length > 1) {

        await NFesStore.download_danfe(ids, this.obs.selectedEmpresa.razao_social);

      }

      this.obs.loading_danfes = false;

    }
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  async handleTotalNotas() {

    if(!this.obs.selectedEmpresa.cnpj) return
    if(!this.obs.filtro) return
    if(!this.obs.tipo) return
    if(!this.obs.selectedPeriod.length) return
    if(this.obs.selectedPeriod.includes("Data inválida")) return
    if(this.obs.selectedPeriod.includes(null)) return

    let params = {
      cnpj: this.obs.selectedEmpresa.cnpj,
      modelo: this.obs.tipo,
      tipo: this.obs.filtro,
      periodo: gerarPeriodos(this.obs.selectedPeriod)
    }

    await NotasStore.handleTotalNotas(params)

  }

  handleChangeTab(tabId) {

    if (String(tabId) == "tarefas") {

      if (!this.obs.selectedEmpresa.cnpj){
        toast.warn("Selecione a empresa!")
        return
      }

      TarefasStore.handleTasksPaged(1);

    } 

    NFesStore.obs.selectedTab = String(tabId)

}

  itens_selecteds() {

    return this.obs.tipo === "NFS-E"
      ? this.obs.list.map(x => x.chave)
      : this.obs.list;

  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      onSelectAll: this.onSelectAll,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      bgColor: "rgba(27, 98, 111, 0.1)",
      selected: this.itens_selecteds()
    };

    const handleBuscaDanfe = async (row) => {

      const ids = this.obs.tipo == "NFS-E"
        ? [{chave: row.chave, cancelada: row.cancelada}]
        : row.id.split(",")

      await NFesStore.view_danfe(this.obs.selectedEmpresa, { filtro: this.obs.filtro, tipo: this.obs.tipo, empresa: this.obs.selectedEmpresa.cnpj, data1: this.state.date1, data2: this.state.date2, ids: ids });

    };

    function copyChave(token: string) {
      copyToClipboard(token);
      toast.success('Chave de Acesso Copiada', {});
    }

    function copyChaveFormatter(cell, row) {
      let danfeFormatter = <></>;
      danfeFormatter = (
        <span onClick={() => copyChave(row.chave)}>{row.chave}</span>
      );
      return danfeFormatter;
    }

    function buttonFormatter(cell, row) {
      let danfeFormatter = <></>;
      danfeFormatter = (
        <img
          src="images/danfe_icon.svg"
          width={25}
          onClick={() => handleBuscaDanfe(row)}
          style={{ cursor: "pointer", display: "inline-block" }}
        />
      );
      return danfeFormatter;
    }

    const buttonCancelada = (cell, row) => {
      if (row.cancelada) {
        return <b style={{ color: "#d95050" }}>SIM</b>
      }

      return (<b>NÃO</b>)
    }

    let items = NFesStore.obs.imps?.map(imp => {
      let cnpjOrig = imp.cnpj_origem ? formatCnpj(imp.cnpj_origem) : "";
      let cnpjDest = imp.cnpj_destino ? formatCnpj(imp.cnpj_destino) : "Não possui";

      return (
        {
          id: this.obs.tipo == "NFS-E" ? imp.chave : imp._id,
          chave: imp.chave,
          numero: imp.nnf,
          tipo: imp.tipo == undefined
            ? "NF-e"
            : imp.tipo == "NFCE"
              ? "NFC-e"
              : imp.tipo == "CT-E"
                ? "CT-e"
                : imp.tipo == "NF-E"
                  ? "NF-e"
                  : imp.tipo,
          cnpj: cnpjOrig + " / " + cnpjDest,
          emissao: imp.tipo == "NF-E"
            ? moment(imp.dhemi).add(3, "hours").format("DD/MM/YY") + " às " + moment(imp.dhemi).add(3, "hours").format("HH:mm")
            : moment(imp.dhemi).format("DD/MM/YY") + " às " + moment(imp.dhemi).format("HH:mm"),
          valor: "R$ " + numeral(imp.valor).format("0,0.00"),
          Origem: imp.cnpj_origem != NFesStore.obs.cnpj_selected
            ? "Entrada"
            : "Saída",
          cancelada: (imp.cancelada || false)
        }
      );
    });

    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)
      })`
      : "Selecione uma empresa";

    const options = {
      page: 1, // which page you want to show as default
      sizePerPageList: [{
        text: "20",
        value: 20,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }], // you can change the dropdown list for size per page
      sizePerPage: 20, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 4, // the pagination bar size.
      prePage: "Ante", // Previous page button text
      nextPage: "Próxima", // Next page button text
      firstPage: "Início", // First page button text
      lastPage: "Última", // Last page button text
      paginationShowsTotal: this.renderShowsTotal, // Accept bool or function
      searchField: this.createCustomSearchField,
    };

    return (

      <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={NFesStore.obs.selectedTab}
          onChange={(tabId) => this.handleChangeTab(tabId)}
      >
        <Tab id="notas" title="Notas" panel={

          <div>

          <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Buscando XMLs"} />
          <LoadingModal open={this.obs.loading_danfes} onClose={() => this.obs.loading_danfes = false} title={"Gerando DANFES"} />
          <LoadingModal open={this.obs.loading_xmls} onClose={() => this.obs.loading_xmls = false} title={"Gerando XMLs"} />

          <MDBRow>
            <MDBCol xl="6" lg="6" md="6" sm="6" xs="6">
              <MDBRow>
                <MDBCol xl="6" lg="6" md="6" sm="6" xs="6">
                  <FormGroup label="Empresa" className="empresaSelect">
                    <EmpresaSelect
                      items={EmpresaStore.sortedEmpresas}
                      itemRenderer={renderEmpresa}
                      itemPredicate={filterEmpresa}
                      onItemSelect={(e: IEmpresa) => {
                        this.obs.selectedEmpresa = e;
                        NFesStore.obs.selectedEmpresa = e;
                        this.handleTotalNotas();
                        NFesStore.obs.imps = [];
                      }}
                      inputProps={{ placeholder: "Filtrar uma empresa" }}
                    >
                      <Button
                        text={empresaText}
                        rightIcon="double-caret-vertical"
                        alignText={Alignment.LEFT}
                      />
                    </EmpresaSelect>
                  </FormGroup>
                </MDBCol>

                <MDBCol xl="3" lg="3" md="3" sm="3" xs="3">
                  <FormGroup
                    label="Tipo"
                    className="nz-horizontal-field selectFullWidth"
                  >
                    <select
                      onChange={this.handleFilterTipoChange}
                      value={this.obs.tipo}
                      className="bp3-button bp3-align-left"
                    >
                      <option value="">Selecione</option>
                      <option value="NF-E">NF-E</option>
                      <option value="NFC-E">NFC-E</option>
                      <option value="CT-E">CT-E</option>
                      <option value="NFS-E">NFS-E</option>
                    </select>
                  </FormGroup>
                </MDBCol>

                <MDBCol xl="3" lg="3" md="3" sm="3" xs="3">
                  <FormGroup
                    label="Origem"
                    className="nz-horizontal-field selectFullWidth"
                  >
                    <select
                      onChange={this.handleFilterChange}
                      value={this.obs.filtro}
                      className="bp3-button bp3-align-left"
                    >
                      <option value="">Selecione</option>
                      {this.obs.tipo == "NFS-E"
                        ?
                        <>
                          <option value="Entrada">Serviços Tomados</option>
                          <option value="Saída">Serviços Prestados</option>
                        </>
                        :
                        <>
                          <option value="Entrada">Entrada</option>
                          <option value="Saída">Saída</option>
                        </>
                      }

                    </select>
                  </FormGroup>
                </MDBCol>
                <MDBCol md="4">
                  <FormGroup label="Período" className="inputsPeriodoCalculos">
                    {NotasStore.obs.total_notas > 20000 && this.obs.tipo == "NFC-E" ?
                      <DateRangePicker10
                        onChange={this.handleDateChange10}
                        value={this.obs.selectedPeriod}
                      />
                      :
                      <DateRangePicker30
                        onChange={this.handleDateChange}
                        value={this.obs.selectedPeriod}
                      />
                    }
                  </FormGroup>
                </MDBCol>
                <MDBCol md="2">
                  <MDBBtn
                    className="btnDefault btnBuscarNfe mt25"
                    onClick={this.handleBuscaClick}
                    disabled={niveis_acesso.indexOf("h1") == -1}
                  >
                    Buscar
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>

          <p><b>Total de notas do período do mês selecionado: </b> {NotasStore.obs.total_notas}</p>

          {NotasStore.obs.total_notas > 20000 && this.obs.tipo == "NFC-E" ?
            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
              <b>Observação: Para volumes superiores a 20.000 notas de NFC-e, a consulta fica limitada a um período máximo de 10 dias.</b>
            </p>
          : <></>}

          <MDBRow>
            <MDBCol md="12" className="btns-Drop">
              <MDBDropdown>
                <MDBDropdownToggle caret className="btnDefault" disabled={niveis_acesso.indexOf("h3") == -1}>
                  Com os Selecionados
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={this.handleDownload} className="actionMani">
                    <img src="/images/xml.svg" width={25} className="iconsActionMani" />{" "}
                    Download XML
                  </MDBDropdownItem>
                  <MDBDropdownItem onClick={this.handleDanfe} className="actionMani">
                    <img src="/images/danfe.svg" width={25} className="iconsActionMani" />{" "}
                    DANFE em PDF
                  </MDBDropdownItem>
                  <MDBDropdownItem onClick={this.handleEventos} className="actionMani">
                    <img src="/images/xml.svg" width={25} className="iconsActionMani" />{" "}
                    Download Eventos
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBCol>
          </MDBRow>

          <div>
            <BootstrapTable className="TableDefault" data={items} selectRow={selectRowProp} options={options} search pagination>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="chave" dataFormat={copyChaveFormatter} width="25%">Chave</TableHeaderColumn>
              <TableHeaderColumn dataField="numero" width="5%">Nº</TableHeaderColumn>
              <TableHeaderColumn dataField="tipo" width="8%">Tipo</TableHeaderColumn>
              <TableHeaderColumn dataField="cnpj" width="30%">Emitente/Destinatário</TableHeaderColumn>
              <TableHeaderColumn dataField="emissao" width="15%">Emissão</TableHeaderColumn>
              <TableHeaderColumn dataField="valor" width="10%">Valor</TableHeaderColumn>
              <TableHeaderColumn dataField="visualizar" dataFormat={buttonFormatter} width="5%">Ver</TableHeaderColumn>
              <TableHeaderColumn dataField="Origem" width="7%">Origem</TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonCancelada} dataField="cancelada" width="5%">Cancelada</TableHeaderColumn>
            </BootstrapTable>
          </div>

          <div style={{ marginBottom: 100 }} />

          </div>

        } />

        <Tab id="tarefas" title="Tarefas NFSe" panel={ <TarefasPage /> } />


      </Tabs>

      
    );
  }
}

export default NFesPage;
